import styled from "styled-components";
import { theme } from "../theme";

export const StyledDecisionCardTags = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 0.5rem;
	flex-wrap: wrap;
	margin-top: 0.75rem;
	margin-bottom: 1rem;
	min-height: 2rem;
	max-height: 6rem;
	overflow-y: auto;
	overflow-x: hidden;
	
	/* Custom scrollbar for webkit browsers */
	&::-webkit-scrollbar {
		width: 4px;
	}
	
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	
	&::-webkit-scrollbar-thumb {
		background: ${theme.color.blue1};
		border-radius: 2px;
	}
	
	&::-webkit-scrollbar-thumb:hover {
		background: ${theme.color.blue2};
	}

	& span {
		margin: 0;
		flex-shrink: 0;
	}
`;
